// extracted by mini-css-extract-plugin
export default {"buttonStyle":"IconTextButton_buttonStyle__g6G5d","buttonIcon":"IconTextButton_buttonIcon__AsYQq"};